// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1qPRv","modalForm":"UpgradeEpcsModal_modalForm__3JGYR","modalFooter":"UpgradeEpcsModal_modalFooter__ZOLrV"};